import { useEffect, useState } from 'react';
import { verifyEmail, VerifyEmailResult } from '../network';
import { VerifyEmailParams } from '../types';

export const useVerifyEmail = (params: VerifyEmailParams) => {
  const { user_id, confirmation_token } = params;
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [error, setError] = useState<Error | null>(null);
  const [result, setResult] = useState<VerifyEmailResult | null>(null);

  useEffect(() => {
    const request = async () => {
      setIsLoading(true);

      try {
        if (!user_id || !confirmation_token) {
          throw new Error('Invalid params');
        }
        const response = await verifyEmail({
          user_id,
          confirmation_token,
        });

        setResult(response);
      } catch (e) {
        if (e instanceof Error) {
          setError(e);
        } else {
          const error = new Error('Unknown error');
          setError(error);
        }
      } finally {
        setIsLoading(false);
      }
    };

    request();
  }, [confirmation_token, user_id]);

  return { isLoading, error, result };
};
